module.exports = __webpack_public_path__ + "static/img/4825_phase_function_Paper_PointsHejduk_Prediction.9e040bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4825_phase_function_Paper_PointsHejduk_Prediction.png
// module id = TYbH
// module chunks = 0